import React from 'react';
import { Alt } from '@heading';
import styles from './ArrowLink.module.scss';
import Arrow from './arrow.svg';
import { Link } from 'gatsby';
import classNames from 'classnames';

export default function ArrowLink({
  className,
  color,
  style = {},
  removeTrailingSlash = true,
  to = '/',
  href,
  direction = 'right',
  children,
  ...restProps
}) {
  to = to.trim();

  if (removeTrailingSlash && to !== '/') {
    to = to.replace(/\/$/, '');
  }

  const isExternal = href || to?.match(/^https?:\/\//);
  const Tag = isExternal ? 'a' : Link;

  return (
    <Tag
      className={classNames(styles.link, className, {
        [styles.left]: direction === 'left'
      })}
      style={{ ...style, color }}
      to={!isExternal ? to : null}
      href={isExternal ? href ?? to : null}
      {...restProps}
    >
      <Alt
        tag="span"
        characters="w"
      >
        {children}
      </Alt>
      <Arrow className={styles.arrow} />
    </Tag>
  );
}
